<google-map height="400px" width="100%" [center]="center" [zoom]="zoom" (mapClick)="moveMap($event)" mapId="experience-map">
    <map-advanced-marker [position]="markerPosition" [options]="markerOptions" />
</google-map>